import React from 'react';
import clsx from 'clsx';
import { getEventPaletteTone } from '../boutique-classroom.mappers';
import { ExpertEventType } from '../boutique-classroom.types';

interface EventTypeLegendProps {
	eventTypes: ExpertEventType[];
}

export const EventTypeLegend: React.FC<EventTypeLegendProps> = ({ eventTypes }) => {
	if (!eventTypes.length) return null;
	return (
		<ul className="event-type-legend">
			{eventTypes.map((eventType, index) => (
				<li
					key={eventType.id}
					className="event-type-legend__item">
					<span className={clsx('event-type-legend__dot', `event-type-legend__dot--${getEventPaletteTone(index)}`)} />
					<span className="event-type-legend__label">{eventType.name}</span>
				</li>
			))}
		</ul>
	);
};

export default EventTypeLegend;
